import React, {useContext, useState} from 'react';
import {QuestionsContext} from '../context/questions';
import Option from './option';

const InitialQuestion = ({item, isActive, data}) => {
    const {Question:title} = item;
    const {nextAction} = useContext(QuestionsContext);
    const [activeRadio, setRadio] = useState("");
    const activeClass = isActive ? "active" : "" ;
    
    function chooseOption(event) {
        setRadio(event.target.value);
    }

    function submitAnswer() {
        const currentId = activeRadio.split("-")[1];
        const numberId = parseInt(currentId);

        const currentAnswer = item.Options.find( function( option ){
            return option.id === numberId;
        } );

        const currentObject = currentAnswer.Options[0];
        
        // once you havedrilled down into the next question object, then call the "nextAction"with the actual question object
        nextAction(currentObject);
    }

    return <div className={`question ${activeClass}`}>
        <div className="titleArea">
            <h2>{title}</h2>
            {item.Description ?
                <div dangerouslySetInnerHTML={{__html: item.Description }} />
                :
                ""
            }
        </div>

        <div className="options">

            {item.Options.map((option, index) =>
                (
                    <Option
                        key={index}
                        index={index}
                        option={option}
                        chooseOption={chooseOption}
                        activeRadio={activeRadio}
                        isActive={isActive}
                    />
                )
            )}
        </div>

        {isActive ? 
            <div className="utility-buttons">
                <button 
                    className="su-button"
                    onClick={submitAnswer} 
                    disabled={!activeRadio}
                    >
                    Next
                </button>
            </div>
            :
            ""
        }
    </div>
    
}

export default InitialQuestion;